<td role="cell" class="product-row__image">
  <div class="product-img-wrapper">
    <img [src]="productImage"
      alt="Foto de {{ product().name }}"
      class="product-thumbnail"
      onerror="this.onerror=null; this.src='/assets/images/image-placeholder.jpg'">
  </div>
</td>

<td role="cell" class="product-row__name fw-bold">{{ product().name }}</td>
<td role="cell" class="product-row__category">{{ product().mainCategory?.name || 'Sin categoría' }}</td>
<td role="cell" class="product-row__price">{{ product().basePrice | clpCurrency }}</td>
<td role="cell" class="product-row__shipping" [class.product-row__shipping--ready]="shippingStatus === 'ready'">
  @switch (shippingStatus) {
    @case ('no_delivery') { <span class="shipping-badge shipping-badge--disabled">Sin envío</span> }
    @case ('ready') { <span class="shipping-badge shipping-badge--ready">{{ shippingDimensionsText }}</span> }
    @default { <span class="shipping-badge shipping-badge--missing">Sin medidas</span> }
  }
</td>
<td role="cell" class="product-row__status">
  <span class="status-badge"
    [class.status-badge--active]="product().status === 'active'"
    [class.status-badge--inactive]="product().status === 'inactive'"
    [class.status-badge--coming-soon]="product().status === 'coming_soon'">
    @switch (product().status) {
      @case ('active') { Activo }
      @case ('inactive') { Inactivo }
      @case ('coming_soon') { Próximamente }
      @default { Sin estado }
    }
  </span>
</td>
<td role="cell" class="product-row__actions">
  <div class="action-buttons">
    <button type="button" class="btn-icon edit" [attr.aria-label]="'Editar ' + product().name" (click)="edit.emit(product())">Editar</button>
    <a
      class="btn-icon external"
      [attr.href]="isViewDisabled ? null : publicUrl"
      target="_blank"
      rel="noopener noreferrer"
      [attr.aria-disabled]="isViewDisabled"
      [class.disabled]="isViewDisabled"
      [tabindex]="isViewDisabled ? -1 : 0"
      [attr.aria-label]="'Ver ' + product().name + ' en tienda (abre otra pestaña)'"
    >
      <span>Ver en tienda</span>
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
        <path d="M14 3h7v7"></path>
        <path d="M10 14L21 3"></path>
        <path d="M21 21H3V3"></path>
      </svg>
    </a>
  </div>
</td>
